import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { SpotCountUpdateModalComponent } from '../spot-count-update-modal/spot-count-update-modal.component';
import { ModifyBookingsPopupComponent } from '../modify-bookings-popup/modify-bookings-popup.component';
import { UpdatePaymentDateModalComponent } from '../update-payment-date-modal/update-payment-date-modal.component';
import { PaymentStatusForMessage } from '@core/models/api-response.model';
import { FilterService } from '@shared/services/filter.service';

@Component({
  selector: 'app-group-modify-bookings-popup',
  templateUrl: './group-modify-bookings-popup.component.html',
  styleUrls: ['./group-modify-bookings-popup.component.scss'],
})
export class GroupModifyBookingsPopupComponent implements OnInit {
  modifyBookingForm: FormGroup;
  showError: boolean = false;
  bookingData: any;
  paymentStatusForMessage = PaymentStatusForMessage;
  showModifyOption: boolean = false;
  showSpotCountModify: boolean = false;
  showPaymentDateUpdate: boolean = false;
  
  constructor(
    private readonly fb: FormBuilder,
    private readonly dialogControlService: DialogControlService,
    private readonly ref: DynamicDialogRef,
    public readonly config: DynamicDialogConfig,
    private readonly filterService: FilterService
  ) {}

  ngOnInit(): void {
    this.bookingData = this.config?.data?.bookingData;
    this.showModifyOption  = this.config?.data?.showModifyOption;
    this.showSpotCountModify =  this.config?.data?.showSpotCountModify;
    this.showPaymentDateUpdate = this.config?.data?.showPaymentDateUpdate;
    this.modifyBookingForm = this.fb.group({
      modifyOption: [null],
    });
  }

  onSubmit(): void {
    this.filterService.preserveDataOnNextNavigation = true;
    if (!this.modifyBookingForm.value.modifyOption) {
      this.showError = true;
      return;
    }
    this.nextPopup();
  }
  setModifyOption(value: any): void {
    this.modifyBookingForm.get('modifyOption')?.setValue(value);
    this.showError = false;
  }
  nextPopup(): void {
    this.closeDialog();
    const modifyOption = this.modifyBookingForm.value.modifyOption;

    const dialogConfig = {
      data: { showPopup: modifyOption,bookingData: this.bookingData },
    };

    if (modifyOption === 'spotCountChange') {
      this.dialogControlService.openDialog(
        SpotCountUpdateModalComponent,
        {
          ...dialogConfig,
          styleClass: 'spot-count-model',
        }
      );
    } else if (modifyOption === 'dateChange') {
      this.dialogControlService.openDialog(
        ModifyBookingsPopupComponent,
        {
          ...dialogConfig,
          styleClass: 'modifypayment',
        }
      );
    } else if (modifyOption === 'paymentDateChange') {
      this.dialogControlService.openDialog(
        UpdatePaymentDateModalComponent,
        {
          ...dialogConfig,
          styleClass: 'spot-count-model',
        }
      );
    }
  }
  
  closeDialog() {
    this.ref.close();
  }
}
